import {useEffect, useState} from 'react';

const DESKTOP_BREAKPOINT = 1320;

const getIsDesktop = () => typeof window !== 'undefined' && window.innerWidth >= DESKTOP_BREAKPOINT;

export const useDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(getIsDesktop);

  useEffect(() => {
    const handleResize = () => setIsDesktop(getIsDesktop());

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isDesktop;
};
